import React from "react";
import imageValentina from "../assets/Valentina-mobile.svg";
function MobileImage() {
  return (
    <div>
      <img src={imageValentina} alt='Valentina Mango' className="" ></img>      
    </div>
  );
}

export default MobileImage;
